import { Link } from 'react-router-dom';

const NotFound = () => {

    return <Link to='/'>
        <div className="container sm">
            <img src='https://images.unsplash.com/photo-1603101021889-94fe1a2226fc?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80' className='responsive-image' alt="not-found" />
        </div>
    </Link>

}

export default NotFound